var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconDetail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 16,
    viewBox: "0 0 21 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.05923 1.06667C8.05923 0.477565 8.5368 0 9.12591 0H19.2C19.7891 0 20.2667 0.477565 20.2667 1.06667C20.2667 1.65578 19.7891 2.13334 19.2 2.13334H9.12591C8.5368 2.13334 8.05923 1.65578 8.05923 1.06667ZM8.05923 5.02859C8.05923 4.43949 8.5368 3.96192 9.12591 3.96192H14.163C14.7521 3.96192 15.2296 4.43949 15.2296 5.02859C15.2296 5.6177 14.7521 6.09527 14.163 6.09527H9.12591C8.5368 6.09527 8.05923 5.6177 8.05923 5.02859Z",
    fill: "#BDBDBD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.13334 2.13334V3.96192H4.02965V2.13334H2.13334ZM0 2.05715C0 0.904046 0.945716 0 2.07408 0H4.08891C5.21728 0 6.16299 0.904046 6.16299 2.05715V4.03811C6.16299 5.19122 5.21728 6.09527 4.08891 6.09527H2.07408C0.945716 6.09527 0 5.19122 0 4.03811V2.05715Z",
    fill: "#BDBDBD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.05923 10.9712C8.05923 10.3821 8.5368 9.90454 9.12591 9.90454H19.2C19.7891 9.90454 20.2667 10.3821 20.2667 10.9712C20.2667 11.5603 19.7891 12.0379 19.2 12.0379H9.12591C8.5368 12.0379 8.05923 11.5603 8.05923 10.9712ZM8.05923 14.9331C8.05923 14.344 8.5368 13.8665 9.12591 13.8665H14.163C14.7521 13.8665 15.2296 14.344 15.2296 14.9331C15.2296 15.5222 14.7521 15.9998 14.163 15.9998H9.12591C8.5368 15.9998 8.05923 15.5222 8.05923 14.9331Z",
    fill: "#BDBDBD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.13334 12.0379V13.8665H4.02965V12.0379H2.13334ZM0 11.9617C0 10.8086 0.945716 9.90454 2.07408 9.90454H4.08891C5.21728 9.90454 6.16299 10.8086 6.16299 11.9617V13.9427C6.16299 15.0958 5.21728 15.9998 4.08891 15.9998H2.07408C0.945716 15.9998 0 15.0958 0 13.9427V11.9617Z",
    fill: "#BDBDBD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDetail);
export default __webpack_public_path__ + "static/media/IconDetail.be081e09395f24b810529d28fa44f599.svg";
export { ForwardRef as ReactComponent };